import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/app/environment';

export const urlInterceptorFn: HttpInterceptorFn = (req, next) => {
  const modifiedReq = req.clone({
    url: req.url.startsWith('/') ? environment.apiBaseUrl + req.url : req.url,
  });

  return next(modifiedReq);
};
